import { status, StatusType } from '../../typeStatus'
import { AutocompleteAvisoResCoreDto } from '../interface'

export const POST_BUMI_AUTOCOMPLETE_AVISO = 'POST_BUMI_AUTOCOMPLETE_AVISO'
export const POST_BUMI_AUTOCOMPLETE_AVISO_SUCCESS = 'POST_BUMI_AUTOCOMPLETE_AVISO_SUCCESS'
export const POST_BUMI_AUTOCOMPLETE_AVISO_ERROR = 'POST_BUMI_AUTOCOMPLETE_AVISO_ERROR'
export const POST_BUMI_AUTOCOMPLETE_AVISO_RESET = 'POST_BUMI_AUTOCOMPLETE_AVISO_RESET'

export interface Bumi {
  data: AutocompleteAvisoResCoreDto
}

export const InitialState: CompanyBumiState = {
  status: status.initial,
  response: null,
  errorCause: null,
}

export interface CompanyBumiState {
  status: StatusType
  response: Bumi | null
  errorCause: string | null
}

export interface PostBumi {
  type: typeof POST_BUMI_AUTOCOMPLETE_AVISO
  payload: null
}
export interface ResponseBumiSuccess {
  type: typeof POST_BUMI_AUTOCOMPLETE_AVISO_SUCCESS
  payload: Bumi
}
export interface ResponseBumiError {
  type: typeof POST_BUMI_AUTOCOMPLETE_AVISO_ERROR
  payload: string | null
}
export interface ResponseBumiReset {
  type: typeof POST_BUMI_AUTOCOMPLETE_AVISO_RESET
  payload: null
}
export type CompanyBumiActions = PostBumi | ResponseBumiSuccess | ResponseBumiError | ResponseBumiReset
